<!--tab-->
<template>
  <van-swipe vertical :autoplay="4000" :show-indicators="false">
    <!-- <van-swipe-item v-for="(value,key) in dataList" :key="key"> -->
    <!-- <div class="center-text" :style="{background: items.colorStr }">{{items.tags}}</div> -->
    <!-- <div class="content-text">{{ value.noticeTitle}}  {{value.noticeContent}}</div> -->
    <!-- <div class="content-text">{{ value.noticeTitle}}</div>
    </van-swipe-item> -->
    <van-swipe-item>
      <div class="content-text">{{ dataList&&dataList.length > 0 ? dataList[0].noticeTitle : ''}}</div>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  components: {},
  props: {
    // 数据
    dataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    heightPx: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="less">
.van-swipe {
  width: 100%;
  font-size: 30px;
  height: 30px;

  .van-swipe__track {
    .van-swipe-item {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}
.center-text {
  height: 18px;
  background: rgba(255, 77, 77, 1);
  border-radius: 1px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 18px;
  text-align: center;
  margin-right: 16px;
  box-sizing: border-box;
  padding: 0 4px;
}
.content-text {
  flex: 1;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}
</style>
